export const CATEGORIES = [
  'Work',
  'Personal',
  'Business',
  'Creative',
  'Technical',
  'Other'
];

export const IDEA_TEMPLATES = [
  {
    id: 'project',
    name: 'Project Idea',
    category: 'Work',
    content: '<h2>Project Overview</h2><p>Brief description of the project...</p><h3>Goals</h3><ul><li>Goal 1</li><li>Goal 2</li></ul><h3>Key Features</h3><ul><li>Feature 1</li><li>Feature 2</li></ul><h3>Timeline</h3><p>Estimated timeline...</p>'
  },
  {
    id: 'feature',
    name: 'Feature Request',
    category: 'Technical',
    content: '<h2>Feature Description</h2><p>What is this feature?</p><h3>Problem It Solves</h3><p>What problem does this solve?</p><h3>User Story</h3><p>As a [user type], I want to [action] so that [benefit].</p><h3>Acceptance Criteria</h3><ul><li>Criteria 1</li><li>Criteria 2</li></ul>'
  },
  {
    id: 'research',
    name: 'Research Idea',
    category: 'Technical',
    content: '<h2>Research Topic</h2><p>What are you researching?</p><h3>Questions to Answer</h3><ul><li>Question 1</li><li>Question 2</li></ul><h3>Resources</h3><ul><li>Resource 1</li><li>Resource 2</li></ul><h3>Expected Outcomes</h3><p>What do you hope to learn?</p>'
  },
  {
    id: 'business',
    name: 'Business Idea',
    category: 'Business',
    content: '<h2>Business Concept</h2><p>Core business idea...</p><h3>Target Market</h3><p>Who are your customers?</p><h3>Value Proposition</h3><p>What makes this unique?</p><h3>Revenue Model</h3><p>How will it make money?</p><h3>Next Steps</h3><ul><li>Step 1</li><li>Step 2</li></ul>'
  },
  {
    id: 'creative',
    name: 'Creative Project',
    category: 'Creative',
    content: '<h2>Creative Vision</h2><p>Describe your creative idea...</p><h3>Inspiration</h3><p>What inspired this?</p><h3>Medium/Format</h3><p>How will it be created?</p><h3>Key Elements</h3><ul><li>Element 1</li><li>Element 2</li></ul>'
  },
  {
    id: 'improvement',
    name: 'Improvement Idea',
    category: 'Work',
    content: '<h2>Current Situation</h2><p>What needs improvement?</p><h3>Proposed Solution</h3><p>How can we improve it?</p><h3>Benefits</h3><ul><li>Benefit 1</li><li>Benefit 2</li></ul><h3>Implementation</h3><p>How to implement this...</p>'
  }
];

export const DAILY_PROMPTS = [
  "What problem have you noticed recently that technology could solve?",
  "If you could improve one thing about your daily routine, what would it be?",
  "What's a skill you'd like to learn, and how could you make it easier for others?",
  "Think of a frustrating experience you had this week. How could it be better?",
  "What would you create if you had unlimited resources?",
  "Combine two unrelated things you love. What emerges?",
  "What's missing from your favorite product or service?",
  "If you could automate one task in your life, what would it be?",
  "What would make your work more enjoyable?",
  "Think of a traditional industry. How could it be reimagined?",
  "What's something people complain about that you could fix?",
  "If you started a company tomorrow, what problem would it solve?",
  "What's an experience you wish existed?",
  "Look around you. What could be redesigned?",
  "What's something you do manually that should be easier?",
  "If you could connect two groups of people, who would they be and why?",
  "What's a trend you've noticed that could become bigger?",
  "What would make your community better?",
  "Think of your favorite hobby. How could you help others enjoy it?",
  "What's an inefficiency you see regularly?",
  "What would you create to help the environment?",
  "What's a service that doesn't exist yet but should?",
  "If you could improve education, where would you start?",
  "What's something beautiful you'd like to create?",
  "What would make healthcare better for everyone?",
  "What's your vision for the future? Start with one idea.",
  "What would you build to bring people together?"
];

export const getDailyPrompt = () => {
  const dayOfYear = Math.floor((new Date() - new Date(new Date().getFullYear(), 0, 0)) / 1000 / 60 / 60 / 24);
  return DAILY_PROMPTS[dayOfYear % DAILY_PROMPTS.length];
};
